import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import InputText from 'modules/_shared/components/InputText';

import { useCommunicationsPage } from '../context/CommunicationsPageContext';
import SignaturePreview from './SignaturePreview';

const SignatureView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useCommunicationsPage();

  return (
    <div className="mt-4">
      <div className="steps clearfix mb-3">
        <ul role="tablist">
          <li role="tab" className="first last current">
            <h5>{t('EmailSignature')}</h5>
          </li>
        </ul>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="mb-3">
            <InputText
              id="signature-name"
              placeholder={t('Name')}
              value={data.signatureName}
              onChange={actions.handleChangeSignatureName}
              onlyInput
            />
          </div>

          <div className="mb-3">
            <InputText
              id="signature-job-title"
              placeholder={t('JobTitle')}
              value={data.signatureJobTitle}
              onChange={actions.handleChangeSignatureJobTitle}
              onlyInput
            />
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <InputText
                id="signature-website"
                placeholder={t('WebSite')}
                value={data.signatureWebsite}
                onChange={actions.handleChangeSignatureWebsite}
                onlyInput
              />
            </div>

            <div className="col-md-6">
              <InputText
                id="signature-phone"
                placeholder={t('Telephone')}
                value={data.signaturePhone}
                onChange={actions.handleChangeSignaturePhone}
                onlyInput
              />
            </div>
          </div>

          <div className="mb-3">
            <InputText
              id="signature-address"
              placeholder={t('Address')}
              value={data.signatureAddress}
              onChange={actions.handleChangeSignatureAddress}
              onlyInput
            />
          </div>

          <InputText
            id="signature-footer"
            placeholder={t('Footer')}
            value={data.signatureFooter}
            onChange={actions.handleChangeSignatureFooter}
            onlyInput
          />
        </div>

        <div className="mt-3 mt-md-0 col-md-6">
          <SignaturePreview />
        </div>
      </div>
    </div>
  );
};

export default SignatureView;
